module.exports = __webpack_public_path__ + "dlssrvtline2/img/favicon.png?341c5f96";